import moment from 'moment';
export default {
    name: 'EditOffice',
    components: {
    },
    created() {   
        window.scrollTo(0, 0);
        this.getOffice(this.$parent.OfficeId);
       
        this.GetAllMunicipalities();

      
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            UserData:null,
            Municipalities: [],
            ruleForm: {
                Name: '',
                Description: '',
                MunicipalityId: '',
                OfficeId: ''
            },
            rules: {
                Name: [
                    { required: true, message: 'الرجاء إدخال اسم المكتب بالعربي', trigger: 'blur' },
                    { min: 2, max: 200, message: 'لقد اجتزت الطول المحدد للمكتب', trigger: 'blur' }
                ],
                Description: [
                    { required: true, message: 'ادخل معلومات عن المكتب', trigger: 'blur' },
                    { min: 2, max: 300, message: 'لقد اجتزت الطول المحدد للمعلومات', trigger: 'blur' }
                ],
            },
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
        };
    },
    methods: {
        GetAllMunicipalities() {
            this.$blockUI.Start();
            this.$http.GetAllMunicipalities()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Municipalities = response.data.municipalities;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },

        getOffice(Id) {

            this.$blockUI.Start();
            this.$http.GetOfficeByOfficeId(Id).then(response => {
                this.$blockUI.Stop();
                console.log(response.data);
                this.ruleForm.Name = response.data.name;
                this.ruleForm.Description = response.data.description;
                this.ruleForm.MunicipalityId = response.data.municipalityId;

            }).catch(error => {
                this.$blockUI.Stop();
                this.$notify({
                    title: 'حدث خطاء',
                    dangerouslyUseHTMLString: true,
                    message: '<strong>' + error.response.data + '</strong>',
                    type: 'error'
                });
            })

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //AddProfiles
                    this.ruleForm.OfficeId = this.$parent.OfficeId;
                    this.$blockUI.Start();
                    this.$http.EditOffice(this.ruleForm)
                        .then(response => {
                            this.$parent.state = 0;
                            this.$parent.GetOffices();
                            this.$blockUI.Stop();
                            this.$notify({
                                title: 'تمت اضافة الـمكتب بنجاح',
                                dangerouslyUseHTMLString: true,
                                message: '<strong>' + response.data + '</strong>',
                                type: 'success'
                            });
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$notify({
                                title: 'خطأ بعملية الاضافة',
                                dangerouslyUseHTMLString: true,
                                type: 'error',
                                message: err.response.data
                            });
                        });
                }
            });
        },

        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        Back() {
            this.$parent.state = 0;
        }


     
    }    
}
